import { render } from "./ProductSlider.vue?vue&type=template&id=1da7b088"
import script from "./ProductSlider.vue?vue&type=script&lang=js"
export * from "./ProductSlider.vue?vue&type=script&lang=js"

import "./ProductSlider.vue?vue&type=style&index=0&id=1da7b088&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__